// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AngleRightSmall: React.FC<{ width?: number; height?: number }> = ({ width = 5, height = 9 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 5 9">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M4.838 4.084a.616.616 0 0 1 0 .832L.996 8.835c-.24.22-.6.22-.816 0a.571.571 0 0 1 0-.833L3.613 4.5.18.998C-.06.778-.06.41.18.165c.216-.22.576-.22.816 0l3.842 3.919Z"
            />
        </svg>
    );
};

export default React.memo(AngleRightSmall);
